<div class="channels__filters">
  @if (channelsFilter()?.length) {
  <div class="channels__filters__checks">
    @for (filter of channelsFilter(); track filter) { @if (filter.type === FiltersTypes.check) {
    <ngx-check-filter [check]="filter"></ngx-check-filter>
    } @if (filter.type === FiltersTypes.selector) {
    <ngx-selector-filter [selector]="filter"></ngx-selector-filter>
    } }
  </div>
  }
</div>
